const decodeHtmlEntities = (text: string) => {
  return text
    .replace(/&nbsp;/g, ' ')
    .replace(/\u00a0/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .normalize('NFKC');
};

export default decodeHtmlEntities;
